import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.scss";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import ReactPWAInstallProvider from "react-pwa-install";

const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
root.render(
  <ReactPWAInstallProvider enableLogging>
    <App />
  </ReactPWAInstallProvider>
);

reportWebVitals();

// serviceWorkerRegistration.register();
